import app from 'flarum/forum/app';
import addComposerAttachments from './addComposerAttachments';
import addDiscussionControls from './addDiscussionControls';
import addLightbox from './addLightbox';
import addLinks from './addLinks';
import addModels from './addModels';
import addPages from './addPages';
import addPostAttachments from './addPostAttachments';
import addPostType from './addPostType';
import addSearch from './addSearch';

export * from './pages';

app.initializers.add('kilowhat-cimaise', () => {
    addComposerAttachments();
    addDiscussionControls();
    addLightbox();
    addLinks();
    addModels();
    addPages();
    addPostAttachments();
    addPostType();
    addSearch();
});
